<p-dialog
  header="AR Statement"
  [modal]="true"
  [closable]="true"
    [(visible)]="visible"
  [style]="{ width: '25rem' }"
  appendTo="body"
  (onHide)="onDialogHide()">

  <!-- CUSTOMER NAME (single field) -->
  <div class="flex items-center gap-4 mb-3">
    <label class="font-semibold w-24">Customer Name</label>
    <p-autoComplete
      #customerName
      class="flex-1"
      [(ngModel)]="customer"
      [suggestions]="customerOptions"
      (completeMethod)="filterCustomers($event)"
      (onSelect)="onCustomerSelect($event)"
      (onClear)="onCustomerCleared(null)"
      (keydown.enter)="onCustomerNameKeyDown()"
      field="CUNM"
      dropdown
      placeholder="Customer name"
      appendTo="body">
    </p-autoComplete>
  </div>

  <!-- CUSTOMER NUMBER (single field) -->
  <div class="flex items-center gap-4 mb-3">
    <label class="font-semibold w-24">Customer Number</label>
    <p-autoComplete
      #customerNumber
      class="flex-1"
      [(ngModel)]="customerNumberObj"
      [suggestions]="customerNumberOptions"
      (completeMethod)="filterCustomerNumbers($event)"
      (onSelect)="onCustomerNumberSelect($event)"
      (onClear)="onCustomerCleared(null)"
      (keydown.enter)="onCustomerNumberKeyDown()"
      field="CUNO"
      placeholder="Customer number"
      dropdown
      [forceSelection]="true"
      appendTo="body">
    </p-autoComplete>
  </div>


 

  <!-- From Date / To Date: same label font as Customer Number, date inputs same width as number field -->
  <div class="flex flex-col gap-4 mb-4">
    <div class="flex items-center gap-4">
      <label class="font-semibold w-24">From Date</label>
      <input
        #fromAccountingDateInput
        type="date"
        class="flex-1 min-w-0 p-2 border border-surface-300 rounded"
        [ngModel]="fromDateValue"
        (ngModelChange)="onFromDateInput($event)"
        (change)="onFromDateChange()"
        (keydown.enter)="onDateKeyDown('FROM')"
        [max]="toDateMax"
      />
    </div>
    <div class="flex items-center gap-4">
      <label class="font-semibold w-24">To Date</label>
      <input
        #toAccountingDateInput
        type="date"
        class="flex-1 min-w-0 p-2 border border-surface-300 rounded"
        [ngModel]="toDateValue"
        (ngModelChange)="onToDateInput($event)"
        (change)="onToDateChange()"
        (keydown.enter)="onDateKeyDown('TO')"
        [min]="toDateMin"
        [max]="todayValue"
      />
    </div>
  </div>

  <!-- ACTIONS -->
  <div class="flex justify-end gap-2">
    <p-button
      label="Clear"
      severity="secondary"
      (click)="onCancel()">
    </p-button>

    <button
      pButton
      #confirmButton
      label="Request AR Statement"
      icon="pi pi-send"
      [disabled]="!isFormValid()"
      (click)="onConfirm()"
      [ngClass]="{ 'p-button-outlined': !confirmButtonFocused }"
      (focus)="confirmButtonFocused = true"
      (blur)="confirmButtonFocused = false"
      (mouseenter)="confirmButtonFocused = true"
      (mouseleave)="confirmButtonFocused = false">
    </button>
  </div>
</p-dialog>